// extracted by mini-css-extract-plugin
export var activeTab = "b8_dS";
export var ratesTableContainer = "b8_hM";
export var tabButton = "b8_dR";
export var tabContainer = "b8_dQ";